export const getOs = () => {
  if (navigator.userAgent.includes("Mac")) {
    return "mac";
  }
  if (navigator.userAgent.includes("Windows")) {
    return "windows";
  }
  if (navigator.userAgent.includes("Linux") || navigator.userAgent.includes("X11")) {
    return "linux";
  }
  return "unknown";
};
